export default "__VITE_ASSET__Bg3OfIjL__"